import React from 'react';
import { withRouter } from "react-router-dom";
import { Divider, Typography } from "../ecosystem";

const VideoVisitOptionsCardHeader = ({
    heading,
    description,
    isMobile,
    showCardHeading
}) => {

    return (
        <div className="card-header">
            <div className="row">
                {showCardHeading &&
                    <div className="col-12 card-heading">
                        <Typography
                            type={isMobile ? "heading-02" : "heading-04"}
                            color="$color-primary-a3"
                            bold={isMobile}
                            textAlign={isMobile ? "left" : "center"}
                            tag="div"
                        >
                            {heading}
                        </Typography>
                    </div>
                }
                <div className="col-12">
                    <Typography type="meta-02" color="$color-secondary-a2">
                        <strong>Benefits include: </strong>
                        {description}
                    </Typography>
                </div>
                
            </div>
        </div>
    )
}

export default withRouter(VideoVisitOptionsCardHeader);